import * as types from '../mutation-types';
import { apis } from '../../services/api';
import router from '../../router';
import cache, {keys} from '../../services/cache';
import push from '../../cordova/push.js';

import globalStore from '../index';

import { networking } from '@/services/api';
import { LangManager } from '@/services/language';

let authApi = apis.authApi;
let userApi = apis.userApi;

const initialState = {
    auth: false,
    user: null,
    token: null,
    recentLogin: false,
    recentRegister: false
};

const state = Object.assign({}, initialState);

// getters
const getters = {
    checkLogin: state => state.auth,
    token: state => state.token,
    authHeader: state => state.auth ? { 'Authorization': 'Bearer ' + state.token, 'Content-Type': 'application/json' } : {},
    user: state => state.user,
    isChofer: state => state.user && state.user.chofer,
    currentTrip: state => {
        if (state.user) {
            if (state.user.chofer) {
                return globalStore.getters['driver/actualTrip'];
            } else {
                return globalStore.getters['passenger/actualTrip'];
            }
        } else {
            return null;
        }
    },
    recentLogin: state => state.recentLogin,
    recentRegister: state => state.recentRegister
};

// actions

function resetState (store) {
    store.commit('RESET_STATES');
}

function onLoggin (store, { token, user }) {
    store.commit(types.AUTH_SET_TOKEN, token);
    store.commit(types.AUTH_SET_USER, user);
    store.commit('RECENT_LOGIN', true);
    if (user && user.lang) {
        console.log('onLoggin setLang', user.lang);
        LangManager.setLang(user.lang);
    }
    globalStore.dispatch('startThread');
    enableBackgroundActivities(store, user);
    if (globalStore.getters['auth/isChofer']) {
        globalStore.dispatch('geolocation/init', 'background');
    } else {
        globalStore.dispatch('geolocation/init', 'foreground');
    }
    router.push({name: 'home'});
}

function login (store, { email, password }) {
    let creds = {};
    creds.email = email;
    creds.password = password;

    let data = Object.assign(creds, store.rootGetters['cordova/deviceData']);
    // data.app_version = store.rootState.appVersion;

    return authApi.login(data).then((response) => {
        onLoggin(store, response);
        return Promise.resolve(response);
    }, (err) => {
        return Promise.reject(err);
    });
}

function resetPassword (store, email) {
    return authApi.resetPassword({email}).then(() => {
        return Promise.resolve();
    }).catch((err) => {
        return Promise.reject(err);
    });
}

function changePassword (store, {token, data}) {
    return authApi.changePassword(token, data).then(() => {
        router.push({ name: 'login' });
        return Promise.resolve();
    }).catch((err) => {
        return Promise.reject(err);
    });
}

function register (store, { email, password, passwordConfirmation, name, sureName, zonaId, termsAndConditions, telefono, lang, tipoBeneficio }) {
    let data = {};
    data.nombre = name;
    data.apellido = sureName;
    data.email = email;
    data.password = password;
    data.password_confirmation = passwordConfirmation;
    data.zona_id = zonaId;
    data.terms = termsAndConditions;
    data.telefono = telefono;
    data.lang = lang;
    if (tipoBeneficio === 'residente' || tipoBeneficio === 'jubilado') {
        data.tipo_beneficio = tipoBeneficio;
    }

    return authApi.registrar(data).then((data) => {
        store.commit('RECENT_REGISTER', true);
        return Promise.resolve(data);
    }).catch((err) => {
        return Promise.reject(err);
    });
}

function retoken (store) {
    let data = {};
    // data.app_version = store.rootState.appVersion;
    data.app_version = globalStore.getters['cordova/version'];
    data.token = store.state.token;
    let idDevice = globalStore.getters['cordova/deviceId'];
    console.log('Device ID: ', idDevice);
    data.device_id = idDevice;
    data.provider = globalStore.getters['cordova/pushNotificationProvider'];
    return new Promise((resolve, reject) => {
        authApi.retoken(data).then((response) => {
            store.commit(types.AUTH_SET_TOKEN, response.token);
            store.commit(types.AUTH_SET_USER, response.user);
            store.commit('RECENT_LOGIN', false);
            // enableBackgroundActivities(store, response.user);
            if (response.device && response.device.device_id === 'NotRegistered') {
                push.refresh();
            }
            resolve();
        }).catch((err) => {
            // check for internet problems -> not resolve until retoken finish
            console.error(err);
            finishSession(store);
            reject(err);
        });
    });
}

function logout (store) {
    return Promise.resolve().then(() => authApi.logoff({})).catch((err) => {
        // Igual cerramos sesión local si el backend responde HTML u otro formato no esperado.
        console.error('Error during remote logout, finishing local session anyway', err);
    }).then(() => {
        finishSession(store);
    });
};

function finishSession (store) {
    // [TODO] FALTA HANDLEAR DE MODO ADECUADO
    let user = store.getters.user;
    if (user) {
        let userType = user.chofer ? 'driver' : 'passenger';
        globalStore.dispatch(userType + '/init', false); // Freno checkState
        globalStore.dispatch(userType + '/resetState'); // Vuelvo los estados a los iniciales así no persisten
    }
    globalStore.dispatch('stopThread');
    globalStore.dispatch('geolocation/stop');
    globalStore.dispatch('tempCache/reset', {key: 'view', subKey: 'register'});
    resetState(store); // Reseteo el state de auth
    store.commit(types.AUTH_LOGOUT); // API LOGOUT
    router.replace({ name: 'login' }); // Show login
}

function update (store, data) {
    let func = 'update';
    if (state.user && state.user.chofer) {
        func += 'Driver';
    } else {
        func += 'Passenger';
    }
    return userApi[func](data).then((response) => {
        let newUser = Object.assign({}, state.user, data);
        store.commit(types.AUTH_SET_USER, newUser);
        return Promise.resolve(response.data);
    }).catch((err) => {
        return Promise.reject(err);
    });
}

function updatePhoto (store, data) {
    return userApi.updatePhoto(data).then((response) => {
        let user = store.getters.user;
        if (user.chofer_id) {
            user.chofer.foto = response;
        } else {
            user.photo = response;
        }
        store.commit(types.AUTH_SET_USER, user);
        return Promise.resolve(response);
    }).catch((err) => {
        return Promise.reject(err);
    });
}

function refreshUser (store) {
    let func = (state.user && state.user.chofer) ? 'getDriverProfile' : 'getPassengerProfile';
    return userApi[func]().then((response) => {
        const user = response && response.data !== undefined ? response.data : response;
        if (user && user.id) {
            store.commit(types.AUTH_SET_USER, user);
        }
        return Promise.resolve(user);
    }).catch((err) => {
        return Promise.reject(err);
    });
}

function enableBackgroundActivities (store, user) {
    if (user.chofer) {
        globalStore.dispatch('driver/init', false);
        globalStore.dispatch('driver/init', true);
    } else {
        // Es pasajero
        globalStore.dispatch('passenger/init', false);
        globalStore.dispatch('passenger/init', true);
    }
}
function updateDevice (store, force) {
    console.log('updateDevice: ', force);
    let data = {};
    // data.app_version = store.rootState.appVersion;
    data.app_version = globalStore.getters['cordova/version'];
    data.token = store.state.token;
    data.device_id = globalStore.getters['cordova/deviceId'];
    data.force = force === undefined ? false : force;
    console.log('Updated Device ID: ', data.device_id);
    return new Promise((resolve, reject) => {
        authApi.updateDevice(data).then((response) => {
            resolve();
        }).catch((err) => {
            reject(err);
        });
    });
}
function changeRecentLogin (store, value) {
    store.commit('RECENT_LOGIN', value);
}

function changeRecentRegister (store, value) {
    store.commit('RECENT_REGISTER', value);
}

const actions = {
    login,
    register,
    retoken,
    logout,
    resetPassword,
    changePassword,
    update,
    refreshUser,
    updatePhoto,
    onLoggin,
    updateDevice,
    enableBackgroundActivities,
    changeRecentLogin,
    changeRecentRegister
};

// mutations
const mutations = {
    RESET_STATES (state) {
        Object.assign(state, initialState);
    },
    RECENT_LOGIN (state, value) {
        state.recentLogin = value;
    },
    RECENT_REGISTER (state, value) {
        state.recentRegister = value;
    },

    [types.AUTH_SET_TOKEN] (state, token) {
        // Parche momentaneo hasta resolver el backend
        networking.setDefualtHeaders({
            'Authorization': 'Bearer ' + token
            // 'Content-Type': 'application/x-www-form-urlencoded'
        });

        state.token = token.replace('"', '');
        state.auth = true;
        cache.setItem(keys.TOKEN_KEY, token);
    },
    [types.AUTH_SET_USER] (state, user) {
        state.user = user;
        cache.setItem(keys.USER_KEY, user);
    },
    [types.AUTH_LOGOUT] (state) {
        state.token = null;
        state.user = null;
        state.auth = false;
        cache.removeItem(keys.USER_KEY);
        cache.removeItem(keys.TOKEN_KEY);
        cache.removeItem(keys.AUTH_KEY);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js